import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const RealisationsPage = lazy(() => import('../pages/realisations/page'));
const CommandeDevisPage = lazy(() => import('../pages/commande-devis/page'));
const OffresEntreprisesPage = lazy(() => import('../pages/offres-entreprises/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/a-propos',
    element: <AboutPage />
  },
  {
    path: '/realisations',
    element: <RealisationsPage />
  },
  {
    path: '/commande-devis',
    element: <CommandeDevisPage />
  },
  {
    path: '/offres-entreprises',
    element: <OffresEntreprisesPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;